import axios from 'axios';
import { checkSubscription } from "../utilities/checkSubscription";

let baseUrl = process.env.REACT_APP_API_BASE_URL
let analyUrl = process.env.REACT_APP_API_ANALYTICS_URL


// check for 401 unauthorized error
axios.interceptors.response.use((response) => response, (error) => {
    console.log(error)
    if (error.response.status === 401) {
        localStorage.clear();
        window.location.assign('/');
    }
    return Promise.reject(error);
});

let api = {


    // seller suth APIs

    auth: {
        login: (pageData) => axios.post(`${baseUrl}login`, pageData)
            .then(res => res.data),
        verifyOtp: (pageData) => axios.post(`${baseUrl}verifyOtp`, pageData)
            .then(res => res.data),
        verifyField: (pageData) => axios.post(`${baseUrl}verifyField`, pageData)
            .then(res => res.data),
        registerSeller: (pageData) => axios.post(`${baseUrl}register`, pageData)
            .then(res => res),
        saveVendorLead: (pageData) => axios.post(`${baseUrl}saveVendorLead`, pageData)
            .then(res => res),
        VerifyVendorLead: (pageData) => axios.post(`${baseUrl}verifyVendorLead`, pageData)
            .then(res => res),
        me: (pageData) => axios.post(`${baseUrl}me`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        sendOtpForSellerPersonalInfoChange: (pageData) => axios.post(`${baseUrl}sendOtpForSellerPersonalInfoChange`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        changeSellerPersonalInfo: (pageData) => axios.post(`${baseUrl}changeSellerPersonalInfo`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        checkVendorFrozen: (pageData) => axios.post(`${baseUrl}checkVendorFrozen`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        requestUnFreeze: (pageData) => axios.post(`${baseUrl}requestUnFreeze`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        unregisterDeviceToken: (pageData) => axios.post(`${baseUrl}unregisterDeviceToken`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },

    // seller product APIs

    product: {
        addToExProduct: (pageData) => axios.post(`${baseUrl}addToExProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updateToExProductRequestStatus: (pageData) => axios.post(`${baseUrl}updateToExProductRequestStatus`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        productsRetrieveall: (pageData) => axios.post(`${baseUrl}productsRetrieveall`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        sellerProductsRetrieveAll: (pageData) => axios.post(`${baseUrl}sellerProductsRetrieveAll`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        addNewProduct: (pageData) => axios.post(`${baseUrl}addNewProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        sellerProductsEditReqRetrieveAll: (pageData) => axios.post(`${baseUrl}sellerProductsEditReqRetrieveAll`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        saveSellerProductsEditReq: (pageData) => axios.post(`${baseUrl}saveSellerProductsEditReq`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        saveSellerWeightChangeReq: (pageData) => axios.post(`${baseUrl}saveSellerWeightChangeReq`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        sellerWeightChangeStsUpdate: (pageData) => axios.post(`${baseUrl}sellerWeightChangeStsUpdate`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        // sl-712
        getSellerWeightChangePendingReq: (pageData) => axios.post(`${baseUrl}getSellerWeightChangePendingReq`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        sellerProductsUpdateOne: (pageData) => axios.post(`${baseUrl}sellerProductsUpdateOne`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        newProductsRetrieveall: (pageData) => axios.post(`${baseUrl}newProductsRetrieveall`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),


        vPriceReqRetrieveAll: (pageData) => axios.post(`${baseUrl}vPriceReqRetrieveAll`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        categoryProductList: (pageData) => axios.post(`${baseUrl}searchProducts`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        vExPrdReqRetrieveAll: (pageData) => axios.post(`${baseUrl}vExPrdReqRetrieveAll`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        sgtPrToAdd: (pageData) => axios.post(`${baseUrl}sgtPrToAdd`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        searchProducts: (pageData) => axios.post(`${baseUrl}searchProducts`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        searchSellerProducts: (pageData) => axios.post(`${baseUrl}searchSellerProducts`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        searchOtherSellerProducts: (pageData) => axios.post(`${baseUrl}searchOtherSellerProducts `, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        saveProductImage: (pageData) => axios.post(`${baseUrl}saveProductImage`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        saveImage: (pageData) => axios.post(`${baseUrl}saveProductImage`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        getProductById: (id) => axios.post(`${baseUrl}/getNewProductById/${id}`, {}, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        addNewProductBulk: (pageData) => axios.post(`${baseUrl}addNewProductBulk`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        deleteNewProductBulk: (id) => axios.post(`${baseUrl}/newProductDeleteOne/${id}`, {}, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        //<Start-Here> Bulk Stock Ticket: SL-733
        //Export Vendor Product Stock
        exportProductStockSheet: () => axios.get(`${baseUrl}exportVendorProductWithStock`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
            responseType: 'blob',
        }),
        //Import Product Vendor Stock
        importProductStockSheet: (pageData) => axios.post(`${baseUrl}importVendorProductWithStock`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        //</End-Here> Bulk Stock Ticket: SL-733

        // I1-2607
         bulkAddToExProduct: (pageData) => axios.post(`${baseUrl}bulkAddToExProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
      
        // l1-2553
        getSellerWeightLockedHistory: (pageData) => axios.post(`${baseUrl}getSellerWeightLockedHistory`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        
        searchSellerProductsFilter: (pageData) => axios.post(`${baseUrl}searchSellerProductsFilter`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        
        saveProductPackageImage: (pageData) => axios.post(`${baseUrl}saveProductPackageImage`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

            
        getBlockedProductsForSeller: (pageData) => axios.post(`${baseUrl}getBlockedProductsForSeller`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },

    supportTicket: {
        getSupportTicket: (pageData) => axios.post(`${baseUrl}getSupportTicket`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        getSupportMessages: (pageData) => axios.post(`${baseUrl}getSupportMessages`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        saveSupportMessages: (pageData) => axios.post(`${baseUrl}saveSupportMessages`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        updateReadMessage: (pageData) => axios.post(`${baseUrl}updateSupportTicket/`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        getSellerSupportMessages: (pageData) => axios.post(`${baseUrl}getSellerSupportMessages`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        saveSellerSupportMessage: (pageData) => axios.post(`${baseUrl}saveSellerSupportMessage`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        readSellerSupportMessage: (pageData) => axios.put(`${baseUrl}readSellerSupportMessage`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

    },
    //   seller brand APIs

    brand: {
        getManufacturers: (pageData) => axios.post(`${baseUrl}getManufacturers`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        brandSubscribe: (pageData) => axios.post(`${baseUrl}brand/store/subscription/add`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        brandSubscribeClbk: (pageData) => axios.post(`${baseUrl}brand/store/subscription/rzp/callback`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        brandTransaction: (pageData) => axios.post(`${baseUrl}brand/store/subscription/transactions`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data)
    },
    customerLeads: {
        getLeads: (pageData) => axios.post(`${baseUrl}leads/list`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        updateStatus: (pageData) => axios.put(`${baseUrl}leads/update`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res),

        addWallet: (pageData) => axios.post(`${baseUrl}wallet/add`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),
        // .then(res => res.data).catch(err => err.response.data),
        getWalletBallence: (pageData) => axios.get(`${baseUrl}wallet`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        getWalletransaction: (pageData) => axios.post(`${baseUrl}wallet/transactions`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        addLeadComment: (pageData) => axios.post(`${baseUrl}leads/save-remarks`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        rzpCallBack: (pageData) => axios.post(`${baseUrl}wallet/rzp/callback`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        getDailyTransactionReport: (pageData) => axios.post(`${baseUrl}leads/daily-report`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        //SL-710 Seller Leads
        getSubscriptionDetails: () => axios.get(`${baseUrl}leads/subscription-details`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => checkSubscription(res.data)),
        getWalletPlans: () => axios.get(`${baseUrl}wallet/plans`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

        getLeadPrice: () => axios.get(`${baseUrl}wallet/getUnlockLeadPrice`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),

    },
    leadChat: {
        createChannel: (pageData) => axios.post(`${baseUrl}leads/create-channel`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        getChannelList: (pageData) => axios.post(`${baseUrl}leads/channel-list`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        saveMessage: (pageData) => axios.post(`${baseUrl}leads/save-msg`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        mesasageList: (pageData) => axios.post(`${baseUrl}leads/msg-list`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        readMessage: (pageData) => axios.post(`${baseUrl}leads/read-msg`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        getUnreadCount: (pageData) => axios.get(`${baseUrl}leads/unread-count`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
    },
    specificInformation: {
        specificInformation: () => axios.get(`${baseUrl}vendor/notification/active`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
        specificInformationList: () => axios.post(`${baseUrl}vendor/notification/list`, {}, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        })
            .then(res => res.data),
    },

    order: {
    orders: (pageData) => axios.post(`${baseUrl}orders`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),
    rocketBoxManifest: (pageData) => axios.post(`${baseUrl}downloadRocketBox`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),
    getRedispatchOrder: (pageData) => axios.post(`${baseUrl}getRedispatchOrder`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),
    updateOrder: (pageData) => axios.post(`${baseUrl}updateOrder`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),
    revokedOrders: (pageData) => axios.post(`${baseUrl}rtoOrders`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),

    searchSellerOrdersFilter: (pageData) => axios.post(`${baseUrl}searchSellerOrdersFilter`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),

    // generate manifest
    generateManifestStepFirst: (pageData) => axios.post(`${baseUrl}generateManifestStepFirst`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),

    generateManifestStepSecond: (pageData) => axios.post(`${baseUrl}generateManifestStepSecond`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),
    logisticErrorLogsRetrieveAll: (pageData) => axios.post(`${baseUrl}logisticErrorLogsRetrieveAll`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),
    //<Start-Here> Raise Concern Ticket: SL-669
    breachingConcern: (data) => axios.post(`${baseUrl}breaching-soon/concern`, data, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),
    //</End-Here> Raise Concern Ticket: SL-669

    // SL-888 Start
    getReverseOrder: (pageData) => axios.post(`${baseUrl}getReverseOrder`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),
    // SL-888 End

    // Sl-910 start
    downloadShipyaari: (pageData) => axios.post(`${baseUrl}downloadShipyaari`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        },
        responseType: "blob"
    },).then(res => res.data),
    // Sl-910 end
    //<Start-Here> Ticket : SL-896
    exportRevokedOrders: (pageData) => axios.post(`${analyUrl}rtoOrdersExp`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        },
        responseType: 'blob',
    }),
    //</End-Here> Ticket : SL-896

    // SL-994 - Self Ship Tracking
    submitSelfShipTracking: (data) => axios.post(
        `${baseUrl}self-ship-tracking`,
        data,
        {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        }
    ).then(res => res.data),

    //<Start-Here> Ticket : SL-988
    getVendorRecentOrders: (pageData) => axios.post(`${baseUrl}getVendorRecentOrders`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    }).then(res => res.data),
    //</End-Here> Ticket : SL-988

    markLostVendorMessagesAsRead: (lost_id) => axios.post(`${baseUrl}markLostVendorMessagesAsRead/${lost_id}`, {},
        {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }
    ).then(res => res.data),
        // SL-1080
    markGrabOrderAsRead: (grab_id) => axios.post(`${baseUrl}markGrabOrderAsRead/${grab_id}`, {},
        {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }
    ).then(res => res.data),

    // SL-1158
    markAllUnreadGrabOrdersAsRead: () => axios.post(`${baseUrl}markAllUnreadGrabOrdersAsRead`, {},
        {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }
    ).then(res => res.data),

        // SL-973 - Lost Orders
        getVendorLostOrders: (pageNo = "1", size = null,purpose) => axios.post(`${baseUrl}getVendorLostOrders`, { pageNo, size, purpose },
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                },
            }
        ).then(res => res.data),

    
    reportWrongProduct: (pageData) => axios.post(`${baseUrl}report-wrong-product`, pageData, {
        headers: {
            'Authorization': 'token ' + localStorage.getItem('token')
        }
    })
        .then(res => res.data),
       delhiveryB2BLabel: (lrnum) => axios.post(
            `${baseUrl}downloadLabel`,
            { lrnum },
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                },
            }
        ).then(res => res.data),

       getDocketByJobId: (pageData) => axios.post(
           `${baseUrl}getDocketByJobId`,
           pageData,
           {
               headers: {
                   'Authorization': 'token ' + localStorage.getItem('token')
               },
           }
       ).then(res => res.data),

       updateOrderKeys: (pageData) => axios.post(
           `${baseUrl}updateOrderKeys`,
           pageData,
           {
               headers: {
                   'Authorization': 'token ' + localStorage.getItem('token')
               },
           }
       ).then(res => res.data),


},
         


    // about Seller

    seller: {
        addAddress: (pageData) => axios.post(`${baseUrl}addressCreateUpdate`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        getSellerAddress: (pageData) => axios.post(`${baseUrl}addressRetrieveall`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        deleteSellerAddress: (pageData) => axios.post(`${baseUrl}addressDelete/${pageData}`, {}, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updatePicture: (pageData) => axios.post(`${baseUrl}updateInfo`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updateDescription: (pageData) => axios.post(`${baseUrl}updateInfo`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updateInfo: (pageData) => axios.post(`${baseUrl}updateInfo`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        vterms: (pageData) => axios.post(`${baseUrl}vterms`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        // l1-2341 (9-9-25)
        saveVendorStockStatus: (pageData) => axios.post(`${baseUrl}vendors/vendor-stock/saveVendorStockStatus`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },


    // notify section


    notify: {
        fetchNotifications: (pageData) => axios.post(`${baseUrl}getVedorActLogs`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updateVendorActLogs: (pageData) => axios.post(`${baseUrl}updateVendorActLogs`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        // Add this new API call
        markActionTaken: (logId) => axios.post(`${baseUrl}markVendorActLogActionTaken`, { logId }, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        closeVendorPriceNotification: (payload) => axios.post(`${baseUrl}closeVendorPriceNotification`, payload, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        closeVendorWeightNotification: (productId, vendorId) => axios.post(`${baseUrl}closeVendorWeightNotification`, { productId, vendorId }, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        closeVendorNewProductNotification: (productId, vendorId) => axios.post(`${baseUrl}closeVendorNewProductNotification`,
            {
                productId,
                vendorId
            },
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                }
            }
        ).then(res => res.data),

        fetchNewProductsNotifications: (pageData) => axios.post(`${baseUrl}getVedorNewProducts`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        fetchTransferPriceNotifications: (pageData) => axios.post(`${baseUrl}getVedorTransferPrice`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        fetchWeightChangedNotifications: (pageData) => axios.post(`${baseUrl}getVedorWeightChanged`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },


    // Review section

    Reviews: {
        fetchReviews: (pageData) => axios.post(`${analyUrl}reviewsRetrieveall`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        fetchReviewsByProduct: (pageData) => axios.post(`${baseUrl}fetchReviewsByProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        fetchSellerReviewsByProduct: (pageData) => axios.post(`${baseUrl}fetchSellerReviewsByProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        reviewsCreate: (pageData) => axios.post(`${baseUrl}reviewsCreate`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },

    // Question Answer Section

    QandA: {
        // fetchQA: (pageData) => axios.post(`${baseUrl}questionAnswerRetrieveall`, pageData, {
        //     headers: {
        //         'Authorization': 'token ' + localStorage.getItem('token')
        //     }
        // }).then(res => res.data),
        fetchQA: (pageData) => axios.post(`${baseUrl}question-answer/get-question`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        // answerQuestions: (pageData) => axios.post(`${baseUrl}submitAnswer`, pageData, {
        //     headers: {
        //         'Authorization': 'token ' + localStorage.getItem('token')
        //     }
        answerQuestions: (pageData) => axios.post(`${baseUrl}question-answer/save`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res),
        ignoreQuestions: (pageData) => axios.post(`${baseUrl}question-answer/ignore`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res),
        QuestionAnswerCount: (pageData) => axios.post(`${baseUrl}question-answer/question-count`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res),
    },

    // Transfer price related

    transferprice: {

        priceChangeRquest: (pageData) => axios.post(`${baseUrl}priceChangeRquest`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updatePriceRequest: (pageData) => axios.post(`${baseUrl}updatePriceRequest`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        updatePriceBulkRequests: (pageData) => axios.post(`${baseUrl}updatePriceBulkRequests`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },

    rto: {
        reportRto: (pageData) => axios.post(`${baseUrl}reportRto`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        addRTONote: (pageData) => axios.post(`${baseUrl}addRTONote`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

    },

    // Vendor ledger

    vendorledger: {

        // Transactions start //
        ledgerData: (pageData) => axios.post(`${analyUrl}getVendorLedgerData`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        // Summary count total price and orders
        ledgersummary: (pagedata) => axios.post(`${analyUrl}getVendorLedgerSummary`, pagedata, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        exportToSheet: (pageData) => axios.post(`${analyUrl}vendorLedgerExp`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
            responseType: 'blob',
        }),

        // Transactions end //

        // Order summary //

        // Order summary data
        ordersummary: (pagedata) => axios.post(`${analyUrl}getOrderSummary`, pagedata, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        // start order summary export report generation
        orderSummaryExp: (pageData) => axios.post(`${analyUrl}orderSummaryExp`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),

        // get latest vendor report status by report type
        getVendorReportStatus: (pageData) => axios.post(`${analyUrl}vendorReports`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),

        // get vendor report download URL by report type
        getVendorReportDownloadUrl: (pageData) => axios.post(`${analyUrl}vendorReports/download`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),

        getSellerReturns: (pagedata) => axios.post(`${baseUrl}getSellerReturns`, pagedata, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        sellerReturnsExp: (pageData) => axios.post(`${baseUrl}sellerReturnsExp`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
            responseType: 'blob',
        }),



        // settlements

        getPaymentSettlements: (pageData) => axios.post(`${baseUrl}getPaymentSettlements`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),


        getPaymentRequests: (pageData) => axios.post(`${baseUrl}getPaymentRequests`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),

        // monthly report 

        getVendorsForMonthlyReport: (pageData) => axios.post(`${baseUrl}getVendorsForMonthlyReport`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),


        // quarterly report 

        getVendorTDSReportByYear: (pageData) => axios.post(`${baseUrl}getVendorTDSReportByYear`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data),

        // download commission invoice

        monthlyReportDataExp: (pageData) => axios.post(`${baseUrl}monthlyReportDataExp`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
            responseType: 'blob',
        }),

        // Order summary data
        orderInvoice: (_id) => axios.get(`${baseUrl}getInvoice/` + _id, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
            responseType: 'blob',
        }),


    },

    // Tutorials

    tutorials: {

        // videos
        getTutorialVids: (pageData) => axios.post(`${baseUrl}getSellerTutorials`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res.data)
    },
    Support: {
        add: (data) => axios.post(`${baseUrl}support`, data, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }),
        sellerReq: (params) => axios.get(`${baseUrl}support/req`, {
            params: params,
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),
        updateSeller: (_id, body) => axios.put(`${baseUrl}support/${_id}`, body, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }),
    },
    // Trademark
    TradeMark: {
        add: (data) => axios.post(`${baseUrl}trademark`, data, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }),
        sellerTradeMark: (pageData) => axios.post(`${baseUrl}trademark/seller`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),
        // SL-938
        activeTradeMark: (pageData) => axios.post(`${baseUrl}trademark/active`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),
        getBrands: () => axios.get(`${baseUrl}trademark/brands`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),
        products: (params) => axios.get(`${baseUrl}trademark/seller-products`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
            params
        }),
        getBrandById: (id) => axios.get(`${baseUrl}trademark/getById/${id}`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),

        // sl - 748
        checkBrand: (data) => axios.post(`${baseUrl}trademark/checkBrand`, data, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),

        updateBrandDets: (data) => axios.put(`${baseUrl}trademark/${data.id}`, data.data, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }),

    },

    // Opportunity section

    Opportunity: {
        fetchOpportunity: (pageData) => axios.post(`${baseUrl}seller-opportunity/seller-opportunity/getOtherOrder`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        fetchOutOfStockOpportunity: (pageData) => axios.post(`${baseUrl}seller-opportunity/seller-opportunity/getOutOfStockForVendor`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        fetchPriceOpportunity: (pageData) => axios.post(`${baseUrl}seller-opportunity/seller-opportunity/vendorPrice`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        deleteOpportunity: (id) => axios.delete(`${baseUrl}seller-opportunity/seller-opportunity/deleteOtherOrder / ${id} `, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        getPriceCompetiveness: () => axios.get(`${baseUrl}seller-opportunity/seller-opportunity/getPriceCompetiveness`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        // sl-758
        getBroadcastProduct: (pageData) => axios.post(`${baseUrl}seller-opportunity/seller-opportunity/getBroadcastProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        getRecommendedProducts: (pageData) => axios.post(`${baseUrl}getVenPrdRecmd`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        updateBroadcastProduct: (pageData) => axios.post(`${baseUrl}seller-opportunity/seller-opportunity/updateBroadcastProduct`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        updateRecommendedProduct: (pageData) => axios.post(`${baseUrl}updateVenPrdRecmd`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),

        getMissedOpportunity: (pageData) => axios.post(`${baseUrl}getMissedOpportunity`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
    },

    // clickpost status 
    clickpost: {

        track: (docketNo, cId) => axios.post(`${baseUrl}trackOrder`, {
            docketNo: docketNo,
            cId: cId
        }, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data)
    },

    notices: {
        getActiveNotices: (vendorId, pageNo = "1", size = null) => axios.post(
            `${baseUrl}getVendorAnnouncements`,
            {
                vendorId,
                pageNo,
                size
            },
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                },
            }
        ).then(res => res),

        getActiveHomeNotices: (vendorId, pageNo = "1", size = null) => axios.post(

            `${baseUrl}getVendorHomeAnnouncements`,
            {
                vendorId,
                pageNo,
                size
            },
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                },
            }
        ).then(res => res),

        acknowledgeNotice: (pageData) => axios.post(`${baseUrl}update-acknowledgement`, pageData, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            },
        }).then(res => res)
    },

    // sl-821
    vendorLead: {
        getVendorLead: (id) => axios.get(`${baseUrl}vendorLead/${id}`, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data),
        vendorLeadProducts: (data) => axios.post(`${baseUrl}vendorLeadProducts`, data)
            .then(res => res.data),
    },

    // Sl-997
    docs: {
        getImage: (data) => axios.post(`${baseUrl}getImage`, data, {
            headers: {
                'Authorization': 'token ' + localStorage.getItem('token')
            }
        }).then(res => res.data)
    },
    //SL-983 Start
    faq: {
        /**
         * Get FAQ categories for vendor
         * @returns Promise with categories list
         */
        getCategories: () => axios.post(
            `${baseUrl}getAllFAQCategories`,
            {
                status: 'Active'
            },
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                }
            }
        ).then(res => res),

        /**
         * Get vendor FAQs with filters
         * @param {Object} payload - { page, limit, category (optional), status }
         * @returns Promise with FAQs list
         */
        getVendorFAQs: (payload) => axios.post(
            `${baseUrl}getVendorFAQs`,
            payload,
            {
                headers: {
                    'Authorization': 'token ' + localStorage.getItem('token')
                }
            }
        ).then(res => res),

    },
    //SL-983 End
};

export default api;

